/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OutBop,
    OutBopFromJSON,
    OutBopFromJSONTyped,
    OutBopToJSON,
} from './';

/**
 * 
 * @export
 * @interface SetSurfaceLayoutsResponse
 */
export interface SetSurfaceLayoutsResponse {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SetSurfaceLayoutsResponse
     */
    activeLayouts: { [key: string]: string; };
    /**
     * 
     * @type {OutBop}
     * @memberof SetSurfaceLayoutsResponse
     */
    bop: OutBop;
}

export function SetSurfaceLayoutsResponseFromJSON(json: any): SetSurfaceLayoutsResponse {
    return SetSurfaceLayoutsResponseFromJSONTyped(json, false);
}

export function SetSurfaceLayoutsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetSurfaceLayoutsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'activeLayouts': json['activeLayouts'],
        'bop': OutBopFromJSON(json['bop']),
    };
}

export function SetSurfaceLayoutsResponseToJSON(value?: SetSurfaceLayoutsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'activeLayouts': value.activeLayouts,
        'bop': OutBopToJSON(value.bop),
    };
}


